import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Loading from "../../../../../pages/Loading/Loading";

const MenuDefault = lazy(() =>
  import("../../../../../features/print-tags").then((module) => ({
    default: module.MenuDefault,
  }))
);

export const Route = createFileRoute(
  "/$lang/_authenticated/menu-print-tags/default"
)({
  component: () => (
    <Suspense fallback={<Loading />}>
      <MenuDefault />

      <div>"test"</div>
    </Suspense>
  ),
});
